import React, { Component, Fragment } from "react";
import { shopContext } from "../contexts/aniplus";
import { withRouter, Link } from "react-router-dom";

import queryString from "query-string";

class Logout extends Component {
  componentDidMount = () => {
    setTimeout(() => {
      this._logout();
    }, 300);
  };
  setCookie = (name, value, exp) => {
    let expires;
    if (exp) {
      var date = new Date();
      date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
      expires = date.toGMTString();
    } else {
      expires = "";
    }

    //console.log(expires)
    document.cookie =
      name +
      "=" +
      value +
      ";path=/;expires=" +
      expires +
      "; SameSite=None; Secure; domain=aniplustv.com"; // SameSite=None; Secure; 실서비스 시 추가할 것.
  };
  _logout = () => {
    const { setLoginId, setAuthId } = this.props;

    const { location } = this.props.childProps;
    const query = queryString.parse(location.search);

    const refer = query.r;
    const param = query.p;

    this.setCookie("account", "");
    this.setCookie("ad", "");
    this.setCookie("at", "");
    this.setCookie("rt", "");

    setLoginId("");
    setAuthId("");

    localStorage.removeItem("at");
    localStorage.removeItem("rt");

    setTimeout(() => {
      // if ( document.referrer ) {
      if (refer === "s") {
        if (param === undefined || param === "" || param === null) {
          document.location.href = "https://shop.aniplustv.com";
        } else {
          document.location.href = "https://shop.aniplustv.com" + param;
        }
      } else if (refer === "d") {
        if (param === undefined || param === "" || param === null) {
          document.location.href = "https://devshop.aniplustv.com";
        } else {
          document.location.href = "https://devshop.aniplustv.com" + param;
        }
      } else if (refer === "ms") {
        document.location.href = "https://mshop.aniplustv.com";
      } else if (refer === "t") {
        document.location.href = "https://www.aniplustv.com/seat/seat.asp";
      } else {
        //history.go(-1, {from: 'login'})
        //clearCache()
        //console.log(history)
        window.location.replace("/");
        //history.push('/')
      }
      //} else {

      //}
    }, 600);
  };
  render() {
    return <></>;
  }
}

export default shopContext(withRouter(Logout));
